<template>
  <div class="H5">

    <div class="swiper-container H5swiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">

            <el-scrollbar ref="H5scroll"
                          style="height: 100%">
              <div style="margin-top:0.3646rem">
                <div class="title_box">H5定制开发服务</div>
                <div class="title_info">强大的兼容性可以显著地降低开发与运营成本，可以让企业特别是创业者获得更多的发展机遇。</div>
                <div class="H5_box">
                  <div class="left_box">
                    <div class="img_box">
                    </div>
                  </div>
                  <div class="right_box">
                    <div class="title">H5应用开发</div>
                    <div class="text">使用主流的H5框架进行开发，支持应用一键打包上架，并支持浏览器、公众号同时访问</div>
                  </div>
                </div>
              </div>
              <div style="margin-top:0.2083rem">
                <div class="title_box">解决方案</div>
                <div class="title_info">视觉设计和交互体验是软件的第一形象，讲究！绝不可以将就！</div>
                <div class="programme">
                  <div class="programme_li">
                    <div class="img_box">
                      <img src="../../static/images/img/shijuejiaohu.png"
                           alt="">
                    </div>
                    <div class="title">交互视觉解决方案</div>
                    <div class="yingyu">UX Solution</div>
                    <div class="text">针对已有清晰产品规划及需求的客户，提供专业精干的交互视觉解决方案，快速实现产品设想，提升产品易用性及美观度。优化产品，提高市场竞争力，助力快速占领市场。</div>
                  </div>
                  <div class="programme_li">
                    <div class="img_box">
                      <img src="../../static/images/img/tiyanjihua.png"
                           alt="">
                    </div>
                    <div class="title">用户体验设计解决方案</div>
                    <div class="yingyu">User Experience</div>
                    <div class="text">针对产品初步构想的客户，提供专业的用户体验设计解决方案。洞察产品痛点，梳理产品需求，多方案用户研究，多维度分析验证产品设想。精准设计落地，放大产品与品牌价值。</div>
                  </div>
                  <div class="programme_li">
                    <div class="img_box">
                      <img src="../../static/images/img/chuangxin.png"
                           alt="">
                    </div>
                    <div class="title">商业创新设计解决方案</div>
                    <div class="yingyu">Business Innovation</div>
                    <div class="text">针对新兴产业及产业升级的客户，协同寻求商业创新机遇，探寻差异化内核，赢得竞争优势。获得溢价盈利，开创新市场、新业态，开创产业与市场新格局。</div>
                  </div>
                </div>
              </div>
              <Footer></Footer>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Banner,
    Footer,
  },
  data () {
    return {
      H5swiper: '',
      H5swiperId: '',
      scrollTop: 0,
    }
  },
  watch: {
    H5swiperId: {
      handler (e) {
        if (e == 1) {
          this.$refs.H5scroll.wrap.scrollTop = 1
          this.H5swiper.disableMousewheelControl()
        }
      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.H5scroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.H5swiper.slidePrev()
        _this.H5swiper.enableMousewheelControl()
      }
    }

    this.H5swiper = new Swiper('.H5swiper', {
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 700, // 每次切换时长
      // scrollbar: '.swiper-scrollbar', // 滚动条
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.H5swiperId = swiper.activeIndex
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.H5 {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .title_info {
    font-size: 0.1146rem;
    font-family: MicrosoftYaHei;
    line-height: 0.2083rem;
    color: #999999;
    opacity: 1;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .H5_box {
    margin: 0 1.875rem;
    display: flex;
    justify-content: space-evenly;
    padding: 0.4063rem 0;
    .left_box {
      position: relative;
      width: 0.9271rem;
      .img_box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.9271rem;
        height: 0.9271rem;
        background-image: url("../../static/images/img/h5Selected.png");
        background-size: 100% 100%;
      }
    }
    .right_box {
      text-align: left;
      .title {
        font-size: 0.1667rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0.2083rem;
        color: #000000;
        opacity: 1;
      }
      .text {
        margin-top: 0.1563rem;
        width: 2.0833rem;
        font-size: 0.0938rem;
        font-family: MicrosoftYaHei;
        line-height: 0.1458rem;
        color: #666666;
        opacity: 1;
      }
    }
  }
  .programme {
    padding: 0 1.875rem;
    margin: 0.3125rem 0.4688rem;
    text-align: left;
    .programme_li {
      position: relative;
      background: #fa7e7d;
      opacity: 1;
      border-radius: 0.1042rem;
      min-height: 0.5208rem;
      padding: 0.1563rem;
      margin-bottom: 0.1563rem;
      .title {
        font-size: 0.1563rem;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        opacity: 1;
      }
      .yingyu {
        margin-top: 0.0521rem;
        font-size: 0.1146rem;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        opacity: 0.7;
      }
      .text {
        font-size: 0.1042rem;
        font-family: MicrosoftYaHei;
        line-height: 0.1771rem;
        color: #ffffff;
        opacity: 1;
        margin-top: 0.1263rem;
      }
      .img_box {
        position: absolute;
        top: 0.1563rem;
        right: 0.1563rem;
        width: 0.4167rem;
        height: 0.3542rem;
      }
    }
    .programme_li:nth-child(2) {
      background-color: #f29912;
    }
    .programme_li:nth-child(3) {
      background-color: #6da3fc;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>